<template>
  <el-container class="main-layout-wrapper" style="height: 100vh;">
    <!-- 侧边栏 -->
    <el-aside class="sidebar" :class="{ collapsed: isCollapsed }" :width="isCollapsed ? '64px' : '220px'">
      <!-- Logo 和公司名区域 -->
      <div class="sidebar-logo">
        <div class="sidebar-logo-inner">
          <img src="../assets/logo.png" alt="Logo" class="sidebar-logo-img">
          <div class="sidebar-logo-text" :class="{ collapsed: isCollapsed }">悦赚客分销后台</div>
        </div>
      </div>

      <el-menu
        :default-active="activeMenu"
        class="sidebar-menu"
        background-color="transparent"
        :text-color="menuTextColor"
        :active-text-color="menuActiveTextColor"
        router
        style="border: none;"
      >
        <el-menu-item index="/data-dashboard">
          <i class="el-icon-data-line"></i>
          <span slot="title">数据大屏</span>
        </el-menu-item>

        <el-menu-item index="/ad-revenue">
          <i class="el-icon-data-analysis"></i>
          <span slot="title">广告收入</span>
        </el-menu-item>

        <el-menu-item index="/system/config">
          <i class="el-icon-setting"></i>
          <span slot="title">系统配置</span>
        </el-menu-item>

        <el-menu-item index="/ip-blacklist">
          <i class="el-icon-lock"></i>
          <span slot="title">IP封控</span>
        </el-menu-item>

        <el-menu-item index="/user-management">
          <i class="el-icon-user-solid"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>

        <el-menu-item index="/distribution-account">
          <i class="el-icon-wallet"></i>
          <span slot="title">分销账户</span>
        </el-menu-item>

        <el-menu-item index="/user-withdrawal">
          <i class="el-icon-money"></i>
          <span slot="title">用户提现</span>
        </el-menu-item>

        <el-menu-item index="/coin-flow">
          <i class="el-icon-refresh"></i>
          <span slot="title">金币流水</span>
        </el-menu-item>

        <el-menu-item index="/official-invite-code">
          <i class="el-icon-key"></i>
          <span>官方邀请码</span>
        </el-menu-item>

        <el-menu-item index="/version-log">
          <i class="el-icon-document"></i>
          <span slot="title">版本日志</span>
        </el-menu-item>
      </el-menu>

      <div v-if="$route.path !== '/data-dashboard'" class="sidebar-icp">
        冀ICP备2024066140号-2
      </div>
    </el-aside>

    <!-- 右侧容器，包含头部和主体 -->
    <el-container>
      <!-- 顶部标签页 -->
      <el-header class="header">
        <div class="header-left">
          <button class="hamburger-btn" @click="toggleSidebar" :title="isCollapsed ? '展开菜单' : '折叠菜单'">
            <svg viewBox="0 0 20 20" width="20" height="20" fill="currentColor">
              <rect x="0" y="2" width="20" height="2" rx="1" />
              <polygon points="2,7 7,10 2,13" />
              <rect x="8" y="7" width="12" height="2" rx="1" />
              <rect x="8" y="11" width="12" height="2" rx="1" />
              <rect x="0" y="16" width="20" height="2" rx="1" />
            </svg>
          </button>
          <div class="header-title">
            <i class="el-icon-star-on header-title-icon"></i>
            <p>欢迎使用</p>
          </div>
        </div>

        <div class="header-right">
          <!-- 用户信息区域 -->
          <el-dropdown @command="handleUserCommand">
            <span class="user-dropdown-link">
              <i class="el-icon-user" style="margin-right: 5px;"></i>
              {{ username || '用户' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 主体区域 -->
      <el-main class="main-content">
        <el-breadcrumb class="page-breadcrumb" separator="/">
          <el-breadcrumb-item :to="{ path: '/ad-revenue' }">
            <i class="el-icon-s-home"></i> 分销后台
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="currentPageName">
            {{ currentPageName }}
          </el-breadcrumb-item>
        </el-breadcrumb>

        <tags-view />

        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </el-main>
    </el-container>

    <!-- 修改密码对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="showPasswordForm"
      width="450px"
      center
    >
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="passwordForm.username" disabled></el-input>
        </el-form-item>

        <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
            placeholder="请输入原密码"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showPasswordForm = false">取 消</el-button>
        <el-button type="primary" @click="submitPasswordForm">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { request, put } from '@/utils/http.js'
import TagsView from '@/components/TagsView.vue'

export default {
  name: 'MainLayout',
  components: { TagsView },
  data() {
    return {
      username: localStorage.getItem('username') || '',
      isCollapsed: localStorage.getItem('sidebarCollapsed') === 'true',
      showPasswordForm: false,
      passwordForm: {
        username: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    menuTextColor() {
      return '#f0f0f0'
    },
    menuActiveTextColor() {
      return '#f0f0f0'
    },
    currentPageName() {
      const nameMap = {
        'AdRevenueQuery': '广告收入',
        'SystemConfigManagement': '系统配置',
        'IpBlacklistManagement': 'IP封控',
        'UserManagement': '用户管理',
        'DistributionAccountManagement': '分销账户',
        'UserWithdrawalManagement': '用户提现',
        'CoinFlowManagement': '金币流水',
        'VersionUpdateLogManagement': '版本日志',
        'OfficialInviteCode': '官方邀请码'
      }
      return nameMap[this.$route.name] || ''
    },
    passwordRules() {
      const validateConfirmPassword = (rule, value, callback) => {
        if (value !== this.passwordForm.newPassword) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          callback()
        }
      }

      return {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在6到20个字符', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在6到20个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed
      localStorage.setItem('sidebarCollapsed', this.isCollapsed)
    },
    handleMenuSelect(key) {
      if (this.$route.path !== key) {
        this.$router.push(key).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }
    },
    async handleUserCommand(command) {
      switch (command) {
        case 'logout':
          try {
            await request('/admin/AdminAccount/logout', { method: 'POST' })
          } catch (error) {
            console.warn('后端退出接口调用失败:', error)
          }
          localStorage.removeItem('token')
          localStorage.removeItem('role')
          localStorage.removeItem('username')
          this.$router.push('/login')
          this.$message.success('已安全退出登录')
          break
        case 'changePassword':
          this.openPasswordForm()
          break
      }
    },
    openPasswordForm() {
      const username = localStorage.getItem('username') || this.username
      if (!username) {
        this.$message.warning('无法获取当前用户名，请重新登录')
        return
      }

      this.passwordForm = {
        username,
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.showPasswordForm = true
      this.$nextTick(() => {
        if (this.$refs.passwordForm) {
          this.$refs.passwordForm.clearValidate()
        }
      })
    },
    submitPasswordForm() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (!valid) {
          return false
        }

        try {
          const response = await put('/admin/AdminAccount/updatePassword', {
            username: this.passwordForm.username,
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          })

          if (response.code === 200) {
            this.$message.success(response.data || '密码修改成功')
            this.showPasswordForm = false
          } else {
            throw new Error(response.msg || '密码修改失败')
          }
        } catch (error) {
          this.$message.error(error.message || '密码修改失败')
        }
      })
    }
  }
}
</script>

<style scoped>
/* ========== Sidebar ========== */
.sidebar {
  position: relative;
  background-color: #000000;
  height: 100%;
  border-right: 1px solid #333333;
  transition: width 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  overflow: hidden;
}

.sidebar-logo {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
  background-color: #000000;
  transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.sidebar-logo-inner {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.sidebar-logo-img {
  max-height: 36px;
  margin-right: 10px;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  flex-shrink: 0;
}

.sidebar-logo-text {
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  max-width: 140px;
  opacity: 1;
  margin-left: 0;
  overflow: hidden;
  white-space: nowrap;
  transition: max-width 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
              opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1),
              margin-left 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.sidebar-logo-text.collapsed {
  max-width: 0;
  opacity: 0;
  margin-left: 0;
}

.sidebar-menu {
  transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.sidebar-menu ::v-deep .el-menu-item {
  transition: padding-left 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
              background-color 0.3s,
              color 0.3s;
}
.sidebar-menu ::v-deep .el-menu-item.is-active {
  background-color: #3D7BE8 !important;
}
.sidebar-menu ::v-deep .el-menu-item span {
  display: inline-block;
  max-width: 120px;
  opacity: 1;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: middle;
  transition: max-width 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
              opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.sidebar.collapsed .sidebar-menu ::v-deep .el-menu-item {
  padding-left: 20px !important;
}
.sidebar.collapsed .sidebar-menu ::v-deep .el-menu-item span {
  max-width: 0;
  opacity: 0;
}

/* ========== Header ========== */
.header {
   background-color: #FFFFFF;
   padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #1a1a1a;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
  height: 60px;
  border-bottom: 1px solid #e8e8e8;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-title {
  color: #1a1a1a;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  height: 100%;
}

/* ========== Hamburger Button ========== */
.hamburger-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #1a1a1a;
  transition: background-color 0.2s, color 0.2s;
}
.hamburger-btn:hover {
  background-color: rgba(0, 0, 0, 0.06);
  color: #3D7BE8;
}

.header-title-icon {
  margin-right: 8px;
  color: #409EFF;
}

.header-right {
  display: flex;
  align-items: center;
  padding-right: 20px;
  gap: 8px;
}

/* ========== User Dropdown ========== */
.user-dropdown-link {
  color: #333333;
  cursor: pointer;
}

/* ========== Main Content ========== */
.main-content {
  padding: 20px;
  background-color: #F5F6FA;
}

.sidebar-icp {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding: 12px 8px;
  font-size: 13px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ========== Breadcrumb ========== */
.page-breadcrumb {
  margin: 0 0 20px 0;
  padding: 0;
  background-color: transparent;
  border-radius: 0;
  border: none;
  font-size: 16px;
}
.page-breadcrumb ::v-deep .el-breadcrumb__inner {
  color: #1a1a1a;
  font-weight: 500;
  transition: color 0.3s;
}
.page-breadcrumb ::v-deep .el-breadcrumb__inner.is-link:hover {
  color: #409EFF;
}
.page-breadcrumb ::v-deep .el-breadcrumb__separator {
  color: #999;
  margin: 0 8px;
}
.page-breadcrumb ::v-deep .el-icon-s-home {
  margin-right: 2px;
}

/* ========== Responsive ========== */
@media (max-width: 768px) {
  .sidebar {
    width: 64px !important;
  }
  .el-aside {
    width: auto !important;
  }
}

/* ========== Text clarity improvements ========== */
.main-layout-wrapper .el-menu-item {
  font-weight: 500;
}
.main-layout-wrapper .el-menu-item.is-active {
  font-weight: 600;
}
.main-layout-wrapper .header-title p {
  font-weight: 600;
  letter-spacing: 0.5px;
}
</style>

<style>
/* ========================================================================
   PREMIUM BUTTON STYLES — 3 Design Variants
   所有按钮样式仅作用于 .main-layout-wrapper 内部，
   不影响 Login / DataDashboard 页面。
   ======================================================================== */

/* ---- Base: 所有按钮通用高级化 ---- */
.main-layout-wrapper .el-button {
  border-radius: 8px;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.main-layout-wrapper .el-button--mini {
  border-radius: 6px;
  letter-spacing: 0.3px;
}

/* ================================================================
   VARIANT A — Gradient Glow (默认 primary / success 渐变发光)
   状态: Default 渐变+投影 / Hover 提亮+上浮 / Active 按压 / Disabled 去饱和
   ================================================================ */
.main-layout-wrapper .el-button--primary {
  background: linear-gradient(135deg, #409EFF 0%, #36a3ff 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  color: #fff;
}
.main-layout-wrapper .el-button--primary:hover {
  background: linear-gradient(135deg, #5cadff 0%, #409EFF 100%);
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.5);
  transform: translateY(-1px);
}
.main-layout-wrapper .el-button--primary:active {
  transform: translateY(0) scale(0.98);
  box-shadow: 0 1px 4px rgba(64, 158, 255, 0.2);
}
.main-layout-wrapper .el-button--primary.is-disabled,
.main-layout-wrapper .el-button--primary:disabled {
  background: linear-gradient(135deg, #a0cfff 0%, #90bfe8 100%);
  box-shadow: none;
  color: #d0d8e8;
  cursor: not-allowed;
}

.main-layout-wrapper .el-button--success {
  background: linear-gradient(135deg, #67c23a 0%, #7ddb4f 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
  color: #fff;
}
.main-layout-wrapper .el-button--success:hover {
  background: linear-gradient(135deg, #7ddb4f 0%, #67c23a 100%);
  box-shadow: 0 4px 16px rgba(103, 194, 58, 0.5);
  transform: translateY(-1px);
}
.main-layout-wrapper .el-button--success:active {
  transform: translateY(0) scale(0.98);
  box-shadow: 0 1px 4px rgba(103, 194, 58, 0.2);
}
.main-layout-wrapper .el-button--success.is-disabled,
.main-layout-wrapper .el-button--success:disabled {
  background: linear-gradient(135deg, #b3e19d 0%, #a4d388 100%);
  box-shadow: none;
  color: #d8e8d0;
  cursor: not-allowed;
}

/* ================================================================
   VARIANT B — Outline Fill (default / info 类型：默认描边，hover 填充)
   状态: Default 描边透明底 / Hover 填充渐变+白字 / Active 按压 / Disabled 浅描边
   ================================================================ */
.main-layout-wrapper .el-button--default {
  background: transparent;
  border: 1.5px solid #d0d5dd;
  color: #606266;
  box-shadow: none;
}
.main-layout-wrapper .el-button--default:hover {
  background: linear-gradient(135deg, #409EFF 0%, #36a3ff 100%);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35);
  transform: translateY(-1px);
}
.main-layout-wrapper .el-button--default:active {
  transform: translateY(0) scale(0.98);
}
.main-layout-wrapper .el-button--default.is-disabled,
.main-layout-wrapper .el-button--default:disabled {
  border-color: #e4e7ed;
  color: #c0c4cc;
  background: transparent;
  cursor: not-allowed;
}

.main-layout-wrapper .el-button--info {
  background: transparent;
  border: 1.5px solid #c0c4cc;
  color: #909399;
  box-shadow: none;
}
.main-layout-wrapper .el-button--info:hover {
  background: linear-gradient(135deg, #909399 0%, #a6a9ad 100%);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 4px 14px rgba(144, 147, 153, 0.35);
  transform: translateY(-1px);
}
.main-layout-wrapper .el-button--info:active {
  transform: translateY(0) scale(0.98);
}
.main-layout-wrapper .el-button--info.is-disabled,
.main-layout-wrapper .el-button--info:disabled {
  border-color: #e4e7ed;
  color: #d0d4d9;
  background: transparent;
  cursor: not-allowed;
}

/* ================================================================
   VARIANT C — Subtle Elegant (danger / warning 细边框+微阴影+内部微光)
   状态: Default 细框+微影 / Hover 强化阴影+上浮+内部光晕 / Active 按压 / Disabled 浅色
   ================================================================ */
.main-layout-wrapper .el-button--danger {
  background: #fff;
  border: 1px solid #fab6b6;
  color: #f56c6c;
  box-shadow: 0 1px 3px rgba(245, 108, 108, 0.12);
}
.main-layout-wrapper .el-button--danger:hover {
  background: #fff5f5;
  border-color: #f56c6c;
  color: #e04747;
  box-shadow: 0 4px 14px rgba(245, 108, 108, 0.3), inset 0 0 0 1px rgba(245, 108, 108, 0.05);
  transform: translateY(-1px);
}
.main-layout-wrapper .el-button--danger:active {
  transform: translateY(0) scale(0.98);
  box-shadow: 0 1px 3px rgba(245, 108, 108, 0.1);
}
.main-layout-wrapper .el-button--danger.is-disabled,
.main-layout-wrapper .el-button--danger:disabled {
  background: #fdf6f6;
  border-color: #fbc4c4;
  color: #fab6b6;
  cursor: not-allowed;
}

.main-layout-wrapper .el-button--warning {
  background: #fff;
  border: 1px solid #f5dab1;
  color: #e6a23c;
  box-shadow: 0 1px 3px rgba(230, 162, 60, 0.12);
}
.main-layout-wrapper .el-button--warning:hover {
  background: #fef9f0;
  border-color: #e6a23c;
  color: #cf9236;
  box-shadow: 0 4px 14px rgba(230, 162, 60, 0.3);
  transform: translateY(-1px);
}
.main-layout-wrapper .el-button--warning:active {
  transform: translateY(0) scale(0.98);
}

/* ========================================================================
   RESPONSIVE LAYOUT — 搜索框 & 按钮区域响应式优化
   覆盖范围: 所有 MainLayout 子组件中的 el-row/el-col 布局
   断点: ≥1920 / 1200-1919 / 992-1199 / 768-991 / 480-767 / <480
   策略: flex-wrap + column-direction 在小屏
   ======================================================================== */

/* 超大屏 ≥1920: 保证最大宽度不溢出 */
@media (min-width: 1920px) {
  .main-layout-wrapper .main-content {
    max-width: 100%;
  }
  .main-layout-wrapper .el-card {
    max-width: 100%;
  }
}

/* 大屏 1200-1919: 保持多列但缩小间距 */
@media (min-width: 1200px) and (max-width: 1919px) {
  .main-layout-wrapper .el-row {
    flex-wrap: wrap;
  }
}

/* 中屏 992-1199: 搜索框列可以折行 */
@media (min-width: 992px) and (max-width: 1199px) {
  .main-layout-wrapper .el-col[class*="el-col-18"],
  .main-layout-wrapper .el-col[class*="el-col-22"] {
    width: 100%;
    margin-bottom: 10px;
  }
  .main-layout-wrapper .el-col[class*="el-col-6"][style*="text-align: right"],
  .main-layout-wrapper .el-col[class*="el-col-6"]:last-child {
    width: 100%;
    text-align: left !important;
    margin-bottom: 0;
  }
  .main-layout-wrapper .query-form-container .el-col[class*="el-col-7"],
  .main-layout-wrapper .query-form-container .el-col[class*="el-col-8"],
  .main-layout-wrapper .query-form-container .el-col[class*="el-col-6"] {
    width: 50%;
    margin-bottom: 10px;
  }
  .main-layout-wrapper .query-form-container .el-col:last-child {
    width: 100%;
    margin-bottom: 0;
  }
  .main-layout-wrapper .search-bar {
    flex-direction: column;
    align-items: stretch !important;
  }
  .main-layout-wrapper .search-bar > * {
    width: 100% !important;
  }
  .main-layout-wrapper .search-bar > div[style*="margin-left: auto"] {
    margin-left: 0 !important;
  }
}

/* 小平板 768-991: 所有列变为全宽堆叠 */
@media (min-width: 768px) and (max-width: 991px) {
  .main-layout-wrapper .el-row > .el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    margin-bottom: 10px;
    text-align: left !important;
  }
  .main-layout-wrapper .el-row > .el-col:last-child {
    margin-bottom: 0;
  }
  .main-layout-wrapper .filter-card [style*="display: flex"] {
    flex-wrap: wrap;
  }
  .main-layout-wrapper .filter-card .el-input,
  .main-layout-wrapper .filter-card .el-select,
  .main-layout-wrapper .filter-card .el-date-picker {
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px;
  }
  .main-layout-wrapper .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .main-layout-wrapper .search-bar {
    flex-direction: column;
    align-items: stretch !important;
  }
  .main-layout-wrapper .search-bar > * {
    width: 100% !important;
  }
  .main-layout-wrapper .search-bar > div[style*="margin-left: auto"] {
    margin-left: 0 !important;
  }
  .main-layout-wrapper .query-form-container .el-row > .el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
  .main-layout-wrapper .query-form-container .el-form-item {
    width: 100% !important;
  }
}

/* 手机横屏 480-767 */
@media (min-width: 480px) and (max-width: 767px) {
  .main-layout-wrapper .el-row > .el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    margin-bottom: 10px;
    text-align: left !important;
  }
  .main-layout-wrapper .filter-card [style*="display: flex"] {
    flex-direction: column;
  }
  .main-layout-wrapper .filter-card .el-input,
  .main-layout-wrapper .filter-card .el-select,
  .main-layout-wrapper .filter-card .el-date-picker {
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px;
    margin-right: 0 !important;
  }
  .main-layout-wrapper .el-form--inline .el-form-item {
    display: block;
    margin-right: 0;
    margin-bottom: 10px;
  }
  .main-layout-wrapper .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-left: 0 !important;
  }
  .main-layout-wrapper .search-bar {
    flex-direction: column;
    align-items: stretch !important;
  }
  .main-layout-wrapper .search-bar > * {
    width: 100% !important;
  }
  .main-layout-wrapper .search-bar > div[style*="margin-left: auto"] {
    margin-left: 0 !important;
  }
  .main-layout-wrapper .query-form-container .el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
}

/* 小手机 <480 */
@media (max-width: 479px) {
  .main-layout-wrapper .el-row > .el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    margin-bottom: 8px;
    text-align: left !important;
  }
  .main-layout-wrapper .filter-card [style*="display: flex"] {
    flex-direction: column;
  }
  .main-layout-wrapper .filter-card .el-input,
  .main-layout-wrapper .filter-card .el-select,
  .main-layout-wrapper .filter-card .el-date-picker {
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px;
    margin-right: 0 !important;
  }
  .main-layout-wrapper .el-form--inline .el-form-item {
    display: block;
    margin-right: 0;
    margin-bottom: 8px;
  }
  .main-layout-wrapper .el-button + .el-button {
    margin-left: 0;
    margin-top: 6px;
  }
  .main-layout-wrapper .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-left: 0 !important;
  }
  .main-layout-wrapper .el-header {
    padding: 0 10px !important;
  }
  .main-layout-wrapper .header-title {
    padding-left: 10px;
    font-size: 14px;
  }
  .main-layout-wrapper .header-right {
    padding-right: 10px;
  }
  .main-layout-wrapper .el-main {
    padding: 10px !important;
  }
  .main-layout-wrapper .search-bar {
    flex-direction: column;
    align-items: stretch !important;
    gap: 8px;
  }
  .main-layout-wrapper .search-bar > * {
    width: 100% !important;
  }
  .main-layout-wrapper .search-bar > div[style*="margin-left: auto"] {
    margin-left: 0 !important;
    flex-direction: column;
  }
  .main-layout-wrapper .query-form-container .el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
  .main-layout-wrapper .pagination-container {
    overflow-x: auto;
  }
}

/* ========================================================================
   DATA BLOCKS — 卡片圆角
   ======================================================================== */
.main-layout-wrapper .el-card {
  border-radius: 10px;
  overflow: hidden;
}
.main-layout-wrapper .filter-card {
  border-radius: 10px !important;
}

/* ========================================================================
   TABLE HEADER — 列标题背景色
   ======================================================================== */
.main-layout-wrapper .el-table th,
.main-layout-wrapper .el-table th.is-leaf {
  background-color: #E8E8E8;
}
.main-layout-wrapper .el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #FFFFFF;
}
.main-layout-wrapper .el-table__body tr:hover > td {
  background-color: #F5F7FA;
}
.main-layout-wrapper .el-table td,
.main-layout-wrapper .el-table th.is-leaf {
  border-right: none;
}
.main-layout-wrapper .el-table--border::after,
.main-layout-wrapper .el-table--group::after,
.main-layout-wrapper .el-table::before {
  background-color: transparent;
}

/* ========================================================================
   ZOOM SCALE FIX — 80%-125% 缩放兼容
   使用 rem/em 相对单位 + min-width 防止元素重叠
   ======================================================================== */
.main-layout-wrapper .filter-card .el-input,
.main-layout-wrapper .filter-card .el-select {
  min-width: 120px;
}
.main-layout-wrapper .filter-card .el-date-picker,
.main-layout-wrapper .filter-card .el-date-editor {
  min-width: 180px;
}
.main-layout-wrapper .query-form-container .el-date-editor {
  min-width: 220px;
}
.main-layout-wrapper .button-group {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
}
.main-layout-wrapper .button-group .el-button {
  white-space: nowrap;
}

/* ---- responsive table horizontal scroll on small screens ---- */
@media (max-width: 991px) {
  .main-layout-wrapper .el-table {
    display: block;
    overflow-x: auto;
  }
}
</style>
